module.exports = __webpack_public_path__ + "static/media/gator-logo.9ebe222a.svg";